import { render, staticRenderFns } from "./ShareTravelNote.vue?vue&type=template&id=d665a932&scoped=true"
import script from "./ShareTravelNote.vue?vue&type=script&lang=js"
export * from "./ShareTravelNote.vue?vue&type=script&lang=js"
import style0 from "./ShareTravelNote.vue?vue&type=style&index=0&id=d665a932&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d665a932",
  null
  
)

export default component.exports